import { createMutationRequestDefinition } from "~/lib/network/definitions/create";

import {
  submitTTSGenerationRequest,
  submitTTSGenerationResponse,
  submitTTSRegenerationRequest,
} from "./schemas";

export const submitVoiceoverGenerationMutation = createMutationRequestDefinition({
  host: "cap-srv",
  method: "POST",
  path: "voiceover/tts/generate/submit",
  paramsSchema: submitTTSGenerationRequest,
  responseSchema: submitTTSGenerationResponse,
});

export const regenerateVoiceoverGenerationMutation = createMutationRequestDefinition({
  host: "cap-srv",
  method: "POST",
  path: "voiceover/tts/regenerate/submit",
  paramsSchema: submitTTSRegenerationRequest,
  responseSchema: submitTTSGenerationResponse,
});
